import type { RawTilesetEntry } from "../tilesetConfigEntry";

export const levelDesignEntries: RawTilesetEntry[] = [
	{
		key: "OpenBlastDoorsTerminal",
		animations: [
			{
				loop: true,
				tags: { active: true },
				height: 2,
				frames: [
					{ filename: "TerminalB_On_0.png", interval: 80 },
					{ filename: "TerminalB_On_1.png", interval: 80 },
				],
			},
			{
				loop: true,
				tags: { inactive: true, no_power: true },
				height: 2,
				frames: [{ filename: "TerminalB_Off_0.png", interval: 0 }],
			},
		],
	},
	{
		key: "ZooReleaseTerminal",
		animations: [
			{
				loop: true,
				tags: { active: true },
				height: 2,
				frames: [
					{ filename: "TerminalB_On_0.png", interval: 80 },
					{ filename: "TerminalB_On_1.png", interval: 80 },
				],
			},
			{
				loop: true,
				tags: { inactive: true, no_power: true },
				height: 2,
				frames: [{ filename: "TerminalB_Off_0.png", interval: 0 }],
			},
		],
	},
	{
		key: "PowerPlantGateTerminal",
		animations: [
			{
				loop: true,
				tags: { active: true },
				height: 2,
				frames: [
					{ filename: "TerminalB_On_0.png", interval: 80 },
					{ filename: "TerminalB_On_1.png", interval: 80 },
				],
			},
			{
				loop: true,
				tags: { inactive: true },
				height: 2,
				frames: [{ filename: "TerminalB_Off_0.png", interval: 0 }],
			},
		],
	},
	{
		key: "WinConditionTerminal",
		animations: [
			{
				loop: true,
				tags: { active: true },
				height: 2,
				frames: [
					{ filename: "TerminalB_On_0.png", interval: 80 },
					{ filename: "TerminalB_On_1.png", interval: 80 },
				],
			},
			{
				loop: true,
				tags: { inactive: true },
				height: 2,
				frames: [{ filename: "TerminalB_Off_0.png", interval: 0 }],
			},
		],
	},
	{
		key: "RobotEntranceTerminal",
		animations: [
			{
				loop: true,
				tags: { active: true },
				height: 2,
				frames: [
					{ filename: "TerminalB_On_0.png", interval: 80 },
					{ filename: "TerminalB_On_1.png", interval: 80 },
				],
			},
			{
				loop: true,
				tags: { inactive: true },
				height: 2,
				frames: [{ filename: "TerminalB_Off_0.png", interval: 0 }],
			},
		],
	},
	{
		key: "PowerPlantSwitch",
		animations: [
			{
				loop: true,
				tags: { off: true },
				frames: [{ filename: "LeverSwitch_Red.png", interval: 0 }],
			},
			{
				loop: true,
				tags: { on: true },
				frames: [{ filename: "LeverSwitch_Green.png", interval: 0 }],
			},
		],
	},
	{
		key: "VendingMachine",
		animations: [
			{
				loop: true,
				tags: { on: true },
				height: 2,
				frames: [
					{ filename: "VendingMachine_0.png", interval: 80 },
					{ filename: "VendingMachine_1.png", interval: 80 },
				],
			},
			{
				loop: true,
				tags: { off: true },
				height: 2,
				frames: [{ filename: "VendingMachine_off.png", interval: 0 }],
			},
		],
	},
	{
		key: "LevelDown",
		sprite: "NextLevel.png",
	},
	{
		key: "LevelUp",
		sprite: "PreviousLevel.png",
	},
	{
		key: "LadderDown",
		animations: [
			{
				loop: true,
				frames: [
					{ filename: "Ladderdown_0.png", interval: 2000 },
					{ filename: "Ladderdown_1.png", interval: 100 },
					{ filename: "Ladderdown_2.png", interval: 100 },
					{ filename: "Ladderdown_1.png", interval: 100 },
				],
			},
		],
	},
	{
		key: "LadderUp",
		animations: [
			{
				loop: true,
				frames: [
					{ filename: "Ladderup_0.png", interval: 2000 },
					{ filename: "Ladderup_1.png", interval: 100 },
					{ filename: "Ladderup_2.png", interval: 100 },
					{ filename: "Ladderup_1.png", interval: 100 },
				],
			},
		],
	},
	{
		key: "Downstairs",
		animations: [
			{
				loop: true,
				frames: [
					{ filename: "Downstairs_0.png", interval: 2000 },
					{ filename: "Downstairs_1.png", interval: 100 },
					{ filename: "Downstairs_2.png", interval: 100 },
					{ filename: "Downstairs_1.png", interval: 100 },
				],
			},
		],
	},
	{
		key: "Upstairs",
		animations: [
			{
				loop: true,
				frames: [
					{ filename: "Upstairs_0.png", interval: 2000 },
					{ filename: "Upstairs_1.png", interval: 100 },
					{ filename: "Upstairs_2.png", interval: 100 },
					{ filename: "Upstairs_1.png", interval: 100 },
				],
			},
		],
	},
	{
		key: "Portal2",
		animations: [
			{
				height: 3,
				width: 3,
				offsetX: -1,
				offsetY: -1,
				loop: true,
				frames: [{ filename: "Portal3-3.png", interval: 0 }],
			},
		],
	},
	{
		key: "ReinforcedPortal2",
		animations: [
			{
				height: 3,
				width: 3,
				offsetX: -1,
				offsetY: -1,
				loop: true,
				frames: [{ filename: "BigPortalReinforced.png", interval: 0 }],
			},
		],
	},
	{
		key: "Portal2Part",
		animations: [],
	},
	{
		key: "ArrowDisplay",
		allowTransform: true,
		animations: [
			{
				loop: true,
				pointsTo: ["E"],
				frames: [{ filename: "ArrowMob_E.png", interval: 0 }],
			},
			{
				loop: true,
				pointsTo: ["NE"],
				frames: [{ filename: "ArrowMob_NE.png", interval: 0 }],
			},
		],
	},
	{
		key: "FloatingArrow",
		animations: [
			{
				loop: true,
				offsetY: 1,
				frames: [
					{ filename: "FloatingArrow_0.png", interval: 250 },
					{ filename: "FloatingArrow_1.png", interval: 250 },
				],
			},
		],
	},
];
